var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 38,
    viewBox: "0 0 36 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0176 2.33331L22.3951 5.52665L27.8142 5.51665L29.4784 10.6733L33.8684 13.85L32.1842 19L33.8684 24.15L29.4784 27.3266L27.8142 32.4833L22.3951 32.4733L18.0176 35.6666L13.6401 32.4733L8.22091 32.4833L6.55675 27.3266L2.16675 24.15L3.85091 19L2.16675 13.85L6.55675 10.6733L8.22091 5.51665L13.6401 5.52665L18.0176 2.33331Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1843 19L16.351 23.1666L24.6843 14.8333",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessTick);
export default __webpack_public_path__ + "static/media/success-tick.e5bc5780ed93676432d57b4938983f76.svg";
export { ForwardRef as ReactComponent };